export interface IrisDmsFolderInfoI {
  folderId: string;
  folderCount?: number;
  folderSize?: number;
  filesInAllSubFolders?: number;
}

export class IrisDmsFolderInfo implements IrisDmsFolderInfoI {
  folderId: string = undefined;
  folderCount: number = undefined;
  folderSize: number = undefined;
  filesInAllSubFolders: number = undefined;

  constructor(folderInfo?: Partial<IrisDmsFolderInfoI>) {
    const newParams = { ...folderInfo };

    if (!!folderInfo) {
      Object.keys(this).forEach((key) => {
        if (newParams[key] !== undefined) {
          this[key] = newParams[key];
        }
      });
    }
  }
}
